// Updated: erp-frontend/src/components/Inventory/LowStockAlert.jsx
import React, { useState, useEffect } from 'react';
import { Button, Tag } from 'antd';
import { 
  ExclamationCircleOutlined, 
  ReloadOutlined, 
  CloseOutlined 
} from '@ant-design/icons';
import api from '../../services/api';
import './LowStockAlert.css';

const LowStockAlert = () => {
  const [lowStockItems, setLowStockItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(true);

  const fetchLowStockItems = async () => {
    try {
      setLoading(true);
      const response = await api.get('/alerts/low-stock');
      if (response.success) {
        const GENERAL_ALERT_ITEMS = ['Earthing Kit + LA', 'ACDB, DCDB', 'Generation Meter'];
        const filtered = response.data.filter(item => {
          if (item.productType === 'SolarPanel' || item.productType === 'Inverter') return true;
          if (item.productType === 'General') {
            return GENERAL_ALERT_ITEMS.some(name =>
              item.productName?.toLowerCase().includes(name.toLowerCase())
            );
          }
          return false;
        });
        setLowStockItems(filtered);
      }
    } catch (error) {
      console.error('Failed to fetch low stock alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLowStockItems();
    // Refresh every 5 minutes
    const interval = setInterval(fetchLowStockItems, 300000);
    return () => clearInterval(interval);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="simple-alert-container">
      <div className="simple-alert-header">
        <div className="simple-header-left">
          <div className="simple-alert-icon">
            <ExclamationCircleOutlined />
            <span className="simple-alert-count">{lowStockItems.length}</span>
          </div>
          <div className="simple-header-text">
            <h3>Low Stock Alert</h3>
            <p>{lowStockItems.length} product(s) below minimum stock level</p>
          </div>
        </div>
        
        <div className="simple-header-right">
          <Button 
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={fetchLowStockItems}
            loading={loading}
            className="simple-refresh-btn"
          />
          <Button 
            type="text"
            size="small"
            icon={<CloseOutlined />}
            onClick={handleDismiss}
            className="simple-dismiss-btn"
          />
        </div>
      </div>
      
      <div className="simple-products-grid">
        {lowStockItems.map((item, index) => {
          const isOutOfStock = item.availableQuantity === 0;
          
          return (
            <div 
              key={item.id || item._id || index} 
              className="simple-product-card"
              style={{ 
                borderLeftColor: isOutOfStock ? '#ff4d4f' : '#fa8c16',
                background: isOutOfStock ? '#fff1f0' : '#fff7e6'
              }}
            >
              <div className="simple-product-main">
                <div className="simple-product-name">
                  <span className="simple-name-text">{item.productName}</span>
                </div>
                <div className="simple-product-sku">
                  {item.sku || item.modelNo || item.productType}
                </div>
              </div>
              
              <div className="simple-product-footer">
                <div className="simple-stock-info">
                  <div className="simple-stock-count">
                    <span className="simple-count-number" style={{ 
                      color: isOutOfStock ? '#ff4d4f' : '#fa8c16'
                    }}>
                      {item.availableQuantity || 0}
                    </span>
                    <span className="simple-count-label">in stock</span>
                  </div>
                  
                  <div className="simple-stock-status">
                    <Tag 
                      color={isOutOfStock ? 'red' : 'orange'} 
                      className="simple-status-tag"
                    >
                      {isOutOfStock ? 'Out of Stock' : 'Low Stock'}
                    </Tag>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="simple-alert-footer">
        <div className="simple-footer-left">
          <span className="simple-total-items">
            <strong>{lowStockItems.length}</strong> items total
          </span>
        </div>
      </div>
    </div>
  );
};

export default LowStockAlert;
